import { ActionType, createAction } from 'typesafe-actions'
import { NavigateFunction } from 'react-router-dom'

import { AddItemToCartGtmData, AddToCartRequestBody, OrderData, OrderItem, OrderMetadata } from './types'

export const OrderActions = {
  loadOrder: createAction('ORDER/load-order')<{
    page?: number
    pageSize?: number
  }>(),
  setOrderMetadata: createAction('ORDER/set-order-id')<{ metadata?: OrderMetadata }>(),
  setOrderItems: createAction('ORDER/set-order-items')<{ items: OrderItem[] }>(),
  removeOrderItem: createAction('ORDER/remove-item')<{ customerRequestId: string }>(),
  loadOrderMetadata: createAction('ORDER/load-order-metadata')(),
  setOrderData: createAction('ORDER/set-order-data')<{ order: OrderData }>(),
  reset: createAction('ORDER/reset')(),
  setOrderError: createAction('ORDER/set-order-error')<{ error: any }>(),
  addToCart: createAction('ORDER/add-to-cart')<{
    companyId?: string
    reportCode: string
    formData: AddToCartRequestBody
    gtmData: AddItemToCartGtmData
    navigate: NavigateFunction
  }>(),
  buyNow: createAction('ORDER/buy-now')<{
    companyId?: string
    reportCode: string
    formData: AddToCartRequestBody
    gtmData: AddItemToCartGtmData
    navigate: NavigateFunction
  }>()
}

export type OrderActions = ActionType<typeof OrderActions>
